import React from 'react';
import './Roadmap.css';

const Roadmap = () => (
  <section className="section road-section" id="roadmap" style={{maxWidth:'100%',paddingLeft:48,paddingRight:48}}>
    <div style={{maxWidth:1240,margin:'0 auto'}}>
      <div className="reveal">
        <div className="eyebrow">Product Roadmap</div>
        <h2 className="section-h2">Features rolling out as we grow</h2>
        <p className="section-sub">Every feature activation is tied to specific regulatory approvals and banking integrations.</p>
      </div>
      <div className="road-grid reveal">
        <div className="road-card phase-now rd1">
          <div className="road-phase">Phase 1 — Now Live</div>
          <span className="road-status status-live">Live</span>
          <h3>Core App &amp; Onboarding</h3>
          <div className="road-items">
            <div className="road-item active"><span className="road-dot"></span>Account registration &amp; OTP</div>
            <div className="road-item active"><span className="road-dot"></span>User profile &amp; KYC UI</div>
            <div className="road-item active"><span className="road-dot"></span>Dashboard &amp; navigation</div>
            <div className="road-item active"><span className="road-dot"></span>Rewards browsing</div>
            <div className="road-item active"><span className="road-dot"></span>Help &amp; support</div>
            <div className="road-item active"><span className="road-dot"></span>Transaction history UI</div>
          </div>
        </div>
        <div className="road-card phase-soon rd2">
          <div className="road-phase">Phase 2 — Next</div>
          <span className="road-status status-soon">Upcoming</span>
          <h3>Payments &amp; Wallet</h3>
          <div className="road-items">
            <div className="road-item"><span className="road-dot"></span>Bill payments (BBPS)</div>
            <div className="road-item"><span className="road-dot"></span>Mobile recharge &amp; DTH</div>
            <div className="road-item"><span className="road-dot"></span>Digital wallet &amp; top-up</div>
            <div className="road-item"><span className="road-dot"></span>Merchant payments</div>
          </div>
          <p style={{fontSize:'.75rem',color:'var(--text-2)',marginTop:12,lineHeight:1.5}}>Requires: BBPS aggregator agreement + RBI PPI license</p>
        </div>
        <div className="road-card phase-later rd3">
          <div className="road-phase">Phase 3 — Later</div>
          <span className="road-status status-later">Planned</span>
          <h3>UPI &amp; Money Transfer</h3>
          <div className="road-items">
            <div className="road-item"><span className="road-dot"></span>UPI QR scan &amp; pay</div>
            <div className="road-item"><span className="road-dot"></span>UPI ID transfer</div>
            <div className="road-item"><span className="road-dot"></span>Bank-to-bank (IMPS/NEFT)</div>
            <div className="road-item"><span className="road-dot"></span>Split &amp; settle</div>
          </div>
          <p style={{fontSize:'.75rem',color:'var(--text-2)',marginTop:12,lineHeight:1.5}}>Requires: NPCI UPI membership via PSP bank</p>
        </div>
        <div className="road-card phase-future rd4">
          <div className="road-phase">Phase 4+ — Future</div>
          <span className="road-status status-future">Roadmap</span>
          <h3>Financial Services</h3>
          <div className="road-items">
            <div className="road-item"><span className="road-dot"></span>Loans &amp; BNPL (RBI/NBFC)</div>
            <div className="road-item"><span className="road-dot"></span>Mutual Funds (SEBI/AMFI)</div>
            <div className="road-item"><span className="road-dot"></span>Insurance (IRDAI)</div>
            <div className="road-item"><span className="road-dot"></span>Travel booking</div>
          </div>
          <p style={{fontSize:'.75rem',color:'var(--text-2)',marginTop:12,lineHeight:1.5}}>Each sub-feature requires separate regulatory approval</p>
        </div>
      </div>
      <div className="road-note reveal">
        <strong style={{color:'var(--text)'}}>No live financial transactions are currently processed.</strong> All payment, loan, investment, and insurance screens visible in the app are UI demonstrations. SequPay will activate each feature only after obtaining the required license or partnership.
      </div>
    </div>
  </section>
);

export default Roadmap;
